import type { FigureLegendEntry } from '../types/payloads/figureLegend.types';
import type { MusicalToken } from '../types/music';

const TOKENS = new Set([
  'W',
  'H',
  'Q',
  'E',
  'S',
  'R_W',
  'R_H',
  'R_Q',
  'R_E',
  'R_S',
]);

export function normalizeFigureLegendEntries(raw: unknown): FigureLegendEntry[] | undefined {
  if (!Array.isArray(raw) || !raw.length) return undefined;
  const out: FigureLegendEntry[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const token = String((item as { token?: string }).token || '').trim();
    const label = String((item as { label?: string }).label || '').trim();
    const duration = String((item as { duration?: string }).duration || '').trim();
    if (!TOKENS.has(token) || !label || !duration) continue;
    out.push({
      token: token as MusicalToken,
      label,
      duration,
      description: (item as { description?: string }).description
        ? String((item as { description: string }).description)
        : undefined,
    });
  }
  return out.length ? out : undefined;
}
